import { ComplexBotComponent } from "../complex-bot.component";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { SessionStorage } from "@shared/SessionStorage";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { LogService } from "@shared/services/log.service";
import { ConfigScreenComplexBotComponent } from "../config-screen/config-screen.complex-bot.component";
import { IboxComponent } from "../../../elements/ibox/ibox.component";
import { FormsModule } from "@angular/forms";


interface RssConfig {
    feeds: {
        [feedUrl: string]: {
            addedByUserId: string;
        };
    };
}

interface LocalFeed {
    url: string;
    addedByUserId: string;
    isSelf: boolean;
}

@Component({
    templateUrl: "rss.complex-bot.component.html",
    styleUrls: ["rss.complex-bot.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ConfigScreenComplexBotComponent, IboxComponent, FormsModule, TranslatePipe]
})
export class RssComplexBotConfigComponent extends ComplexBotComponent<RssConfig> {

    public newFeedUrl = "";

    constructor(
        public translate: TranslateService,
        logService: LogService,
    ) {
        super("rss", translate, logService);
        this.translate = translate;
    }

    public addFeed(): void {
        if (!this.newFeedUrl.trim()) {
            this.translate.get('Please enter a feed URL').subscribe((res: string) => {
                this.toaster.pop('warning', res);
            });
            return;
        }

        this.newConfig.feeds[this.newFeedUrl] = {addedByUserId: SessionStorage.userId};
        this.newFeedUrl = "";
    }

    public getFeeds(): LocalFeed[] {
        if (!this.newConfig.feeds) this.newConfig.feeds = {};
        return Object.keys(this.newConfig.feeds).map(url => {
            return {
                url: url,
                addedByUserId: this.newConfig.feeds[url].addedByUserId,
                isSelf: SessionStorage.userId === this.newConfig.feeds[url].addedByUserId,
            };
        });
    }

    public removeFeed(feed: LocalFeed): void {
        delete this.newConfig.feeds[feed.url];
    }

    public async interceptSave(): Promise<any> {
        const memberEvent = await this.scalarClientApi.getMembershipState(this.roomId, this.bot.notificationUserId);
        const isJoined = memberEvent?.response && ["join", "invite"].includes(memberEvent.response.membership);

        if (!isJoined) {
            await this.scalarClientApi.inviteUser(this.roomId, this.bot.notificationUserId);
        }

        super.save();
    }
}
